module.exports = __webpack_public_path__ + "img/img-85.1c8a9329.png";